import React from 'react';

import { useLanguage } from '../i18n';
import Rider from '../assets/ronda/rider.webp';
import TajiboBranch from '../assets/ronda/tajibo-branch.webp';

// Wheel geometry in rider.webp pixels (848×1100). The deck and the fork are
// drawn over the wheels, so the spinning marks are clipped where they cross.
const wheels = [
  {
    id: 'rear',
    cx: 207,
    cy: 992.5,
    hub: 22,
    rim: 46,
    tread: 62,
    // Deck crossing the right half of the rear wheel.
    cover: 'M208 977H848V1009H208Z',
  },
  {
    id: 'front',
    cx: 734.5,
    cy: 988,
    hub: 30,
    rim: 48,
    tread: 65,
    // Fork running from the handlebar stem down to the hub.
    cover: 'M688 860H726L752 990H714Z',
  },
];

const SpinningWheels = () => (
  <svg viewBox='0 0 848 1100' className='absolute inset-0 h-full w-full' aria-hidden='true'>
    <defs>
      {wheels.map((wheel) => (
        <clipPath key={wheel.id} id={`wheel-clip-${wheel.id}`} clipRule='evenodd'>
          <path clipRule='evenodd' d={`M0 0H848V1100H0Z ${wheel.cover}`} />
        </clipPath>
      ))}
    </defs>
    {wheels.map(({ id, cx, cy, hub, rim, tread }) => {
      const treadLength = 2 * Math.PI * tread;
      return (
        <g key={id} clipPath={`url(#wheel-clip-${id})`}>
          <g className='hero-wheel' style={{ transformOrigin: `${cx}px ${cy}px` }}>
            {[0, 120, 240].map((angle) => (
              <line
                key={angle}
                x1={cx}
                y1={cy - hub}
                x2={cx}
                y2={cy - rim}
                transform={`rotate(${angle} ${cx} ${cy})`}
                stroke='#D9824F'
                strokeWidth='6'
                strokeLinecap='round'
              />
            ))}
            <circle
              cx={cx}
              cy={cy}
              r={tread}
              fill='none'
              stroke='#FFFFFF'
              strokeOpacity='0.22'
              strokeWidth='5'
              strokeLinecap='round'
              strokeDasharray={`${treadLength / 16} ${treadLength / 16}`}
            />
          </g>
        </g>
      );
    })}
  </svg>
);

const Hero = () => {
  const { hero } = useLanguage().t;

  return (
    <section id='top' className='relative overflow-hidden'>
      <img
        src={TajiboBranch}
        alt=''
        aria-hidden='true'
        className='hero-sway pointer-events-none absolute -right-8 -top-8 hidden w-[clamp(330px,calc(50vw_-_260px),560px)] lg:block'
      />
      <div className='container relative grid items-center gap-12 pb-16 pt-10 lg:grid-cols-[1.05fr_1fr] lg:gap-8 lg:pb-24 lg:pt-16'>
        <div className='hero-text max-w-[560px]'>
          <p className='mb-6 text-sm font-medium text-muted'>{hero.place}</p>
          <h1 className='display'>
            {hero.title[0]}
            <br />
            <span className='text-ronda'>{hero.title[1]}</span>
          </h1>
          <p className='lead mt-6 max-w-[420px]'>{hero.subtitle}</p>
        </div>

        <div className='relative mx-auto aspect-square w-full max-w-[560px]' aria-hidden='true'>
          <img
            src={TajiboBranch}
            alt=''
            className='hero-sway absolute -right-[4%] -top-[2%] w-[54%] lg:hidden'
          />
          <div className='absolute bottom-[6%] left-[4%] right-[4%] h-px bg-ink/15' />
          <div className='hero-ride absolute inset-0'>
            <div className='absolute bottom-[4.5%] left-[30%] h-[3%] w-[52%] rounded-[50%] bg-ink/[0.06]' />
          </div>
          <div className='hero-ride absolute inset-x-0 bottom-[5%] flex h-[88%] justify-center'>
            <div className='relative h-full'>
              <img src={Rider} alt='' className='h-full w-auto max-w-none' />
              <SpinningWheels />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
